export default "__VITE_ASSET__BWZdfwd4__"